import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMobileScreen,
  faStar,
  faShieldHalved,
  faUserGear,
} from '@fortawesome/free-solid-svg-icons';
import './trust-strip.css';

const TRUST_ITEMS = [
  {
    id: 1,
    icon: faMobileScreen,
    value: '1000+',
    label: 'Perangkat Diperbaiki',
  },
  {
    id: 2,
    icon: faStar,
    value: '99%',
    label: 'Tingkat Keberhasilan',
  },
  {
    id: 3,
    icon: faShieldHalved,
    value: '24',
    suffix: 'Bulan',
    label: 'Garansi Layanan',
  },
  {
    id: 4,
    icon: faUserGear,
    value: 'Pro',
    label: 'Teknisi Ahli',
  },
];

const TrustStrip = () => (
  <section className="trust-strip" aria-label="Keunggulan dan kepercayaan layanan">
    <div className="container">
      <ul className="trust-strip__grid">
        {TRUST_ITEMS.map((item, index) => (
          <li
            key={item.id}
            className="trust-strip__item"
            data-aos="fade-up"
            data-aos-delay={index * 60}
          >
            <span className="trust-strip__icon" aria-hidden="true">
              <FontAwesomeIcon icon={item.icon} />
            </span>
            <div className="trust-strip__content">
              <span className="trust-strip__value">
                {item.value}
                {item.suffix && (
                  <span className="trust-strip__suffix"> {item.suffix}</span>
                )}
              </span>
              <span className="trust-strip__label">{item.label}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TrustStrip;
